// Product Showcase Section JS
window.initProductShowcaseSection = function(sectionId) {
  const sectionRoot = document.getElementById(`shopify-section-${sectionId}`) || document;
  const showcases = sectionRoot.querySelectorAll(`[data-parts-showcase="${sectionId}"]`);

  if (!showcases.length) return;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function generateBadge(tags) {
    if (!tags || !Array.isArray(tags)) return '';

    const tagsLower = tags.map(tag => String(tag).toLowerCase());
    if (tagsLower.includes('new')) {
      return `<span class="parts-product-badge-${sectionId} parts-badge-new-${sectionId}">New</span>`;
    }
    if (tagsLower.includes('hot')) {
      return `<span class="parts-product-badge-${sectionId} parts-badge-hot-${sectionId}">Hot</span>`;
    }
    return '';
  }

  function createProductCard(product) {
    const productUrl = escapeAttribute(product.url || product.handle && `/products/${product.handle}` || '#');
    const productTitle = escapeHtml(product.title || '');
    const imageAlt = escapeAttribute(product.featured_image_alt || product.title);
    const featuredImage = product.featured_image || (product.images && product.images[0] && product.images[0].src) || null;
    const imageHtml = featuredImage
      ? `<img src="${escapeAttribute(featuredImage)}" alt="${imageAlt}" class="parts-product-image-${sectionId}" loading="lazy">`
      : `<div class="parts-product-image-placeholder-${sectionId}"><span>No image</span></div>`;

    const tags = product.tags || [];
    const badge = generateBadge(Array.isArray(tags) ? tags : (typeof tags === 'string' ? tags.split(',').map(t => t.trim()) : []));
    const available = product.available !== undefined ? product.available : true;
    const soldOutBadge = !available
      ? `<div class="parts-sold-out-badge-${sectionId}">Sold out</div>`
      : '';

    return `
      <div class="parts-product-wrapper-${sectionId}">
        <div class="parts-product-card-${sectionId}">
          <a href="${productUrl}" class="parts-product-image-wrapper-${sectionId}">
            ${imageHtml}
            ${soldOutBadge}
          </a>
          <div class="parts-product-info-${sectionId}">
            <div class="parts-product-title-row-${sectionId}">
              <span class="parts-product-title-${sectionId}">${productTitle}</span>
              ${badge}
            </div>
            <div class="parts-product-actions-${sectionId}">
              <a href="${productUrl}" class="parts-product-link-${sectionId}">Shop &gt;</a>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  showcases.forEach(showcase => {
    const productsGrid = showcase.querySelector('[data-parts-products-grid]');
    const navItems = showcase.querySelectorAll(`.parts-nav-item-${sectionId}`);
    let loadRequestId = 0;

    if (!productsGrid || !navItems.length) return;

    function showNoCollectionMessage() {
      productsGrid.classList.remove('loading');
      productsGrid.innerHTML = `<div class="parts-no-collection-message-${sectionId}">Please select a collection in the theme settings.</div>`;
    }

    function showNoProductsMessage(collectionTitle) {
      productsGrid.classList.remove('loading');
      productsGrid.innerHTML = `<div class="parts-no-collection-message-${sectionId}">${escapeHtml(collectionTitle)} has no products.</div>`;
    }

    function loadCollection(blockId) {
      const requestId = ++loadRequestId;
      productsGrid.classList.add('loading');

      const collectionDataScript = document.getElementById(`parts-collection-data-${blockId}-${sectionId}`);
      if (!collectionDataScript) {
        showNoCollectionMessage();
        return;
      }

      try {
        const collectionData = JSON.parse(collectionDataScript.textContent);

        if (collectionData.products && collectionData.products.length > 0) {
          // Data preloaded — use it directly (fallback for any JSON still preloaded)
          window.setTimeout(() => {
            if (requestId !== loadRequestId) return;
            productsGrid.classList.remove('loading');
            productsGrid.innerHTML = collectionData.products.map(createProductCard).join('');

            if (typeof gtag !== 'undefined') {
              gtag('event', 'collection_switch', {
                event_category: 'navigation',
                event_label: collectionData.collection_title,
                section_id: sectionId
              });
            }
          }, 300);
        } else if (collectionData.api_url) {
          // Fetch from Storefront API — lazy load on demand
          fetch(collectionData.api_url)
            .then(r => {
              if (!r.ok) throw new Error('Network response was not ok');
              return r.json();
            })
            .then(json => {
              if (requestId !== loadRequestId) return;
              const products = json.products || json;
              productsGrid.classList.remove('loading');
              if (!products || products.length === 0) {
                showNoProductsMessage(collectionData.collection_title);
                return;
              }
              productsGrid.innerHTML = products.map(createProductCard).join('');

              if (typeof gtag !== 'undefined') {
                gtag('event', 'collection_switch', {
                  event_category: 'navigation',
                  event_label: collectionData.collection_title,
                  section_id: sectionId
                });
              }
            })
            .catch(() => {
              if (requestId !== loadRequestId) return;
              showNoProductsMessage(collectionData.collection_title);
            });
        } else {
          showNoCollectionMessage();
        }
      } catch (error) {
        console.error('Error parsing collection data:', error);
        showNoCollectionMessage();
      }
    }

    function activateNavItem(item) {
      const collectionHandle = item.dataset.collection;
      const blockId = item.dataset.blockId;

      navItems.forEach(nav => nav.classList.remove('active'));
      item.classList.add('active');

      if (!collectionHandle) {
        loadRequestId += 1;
        showNoCollectionMessage();
        return;
      }

      loadCollection(blockId);
    }

    navItems.forEach(item => {
      if (item.dataset.partsNavBound === 'true') return;
      item.dataset.partsNavBound = 'true';

      item.addEventListener('mouseenter', () => activateNavItem(item));
      item.addEventListener('focus', () => activateNavItem(item));
      item.addEventListener('click', () => {
        activateNavItem(item);
      });
    });

    const firstNavItem = navItems[0];
    if (firstNavItem && productsGrid.dataset.partsInitialized !== 'true') {
      productsGrid.dataset.partsInitialized = 'true';
      const firstCollectionHandle = firstNavItem.dataset.collection;
      const firstBlockId = firstNavItem.dataset.blockId;

      if (firstCollectionHandle) {
        loadCollection(firstBlockId);
      } else {
        showNoCollectionMessage();
      }
    }
  });

  window.__partsProductShowcaseClickHandlers = window.__partsProductShowcaseClickHandlers || {};
  if (!window.__partsProductShowcaseClickHandlers[sectionId]) {
    document.addEventListener('click', function(e) {
      const productWrapper = e.target.closest(`.parts-product-wrapper-${sectionId}`);
      if (!productWrapper) return;

      const productTitle = productWrapper.querySelector(`.parts-product-title-${sectionId}`)?.textContent || '';
      if (typeof gtag !== 'undefined') {
        gtag('event', 'product_click', {
          event_category: 'engagement',
          event_label: productTitle,
          section_id: sectionId
        });
      }
    });
    window.__partsProductShowcaseClickHandlers[sectionId] = true;
  }
};
